import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";

import Home from "./components/pages/Home";

import Tracking from "./components/pages/Tracking";
import TrackingBox from "./components/pages/TrackingBox";
import About from "./components/pages/About";
import Footer from "./components/Footer/Footer";
import ContactUs from "./components/pages/ContactUs";
import PrivacyPolicy from "./components/pages/PrivacyPolicy";
import TermsConditions from "./components/pages/Terms&Conditions";
import CookiePolicy from "./components/pages/CookiePolicy";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />  
      <Navbar />
      

      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/shipping" element={<Shipping />} /> */}
        <Route path="/tracking" element={<Tracking />} />
        <Route path="/about" element={<About />} />
        <Route path="/tracking-box" element={<TrackingBox />} />
        <Route path="/Contact" element={<ContactUs />} />
         <Route path="/privacy" element={<PrivacyPolicy />} />
         <Route path="/terms" element={<TermsConditions />} />
         <Route path="/cookies" element={<CookiePolicy />} />
      </Routes>
       <Footer/>
    </BrowserRouter>
  );
}

export default App;
